export const SET_CONTRACT = 'SET_CONTRACT'
export const RESET_CONTRACT = 'RESET_CONTRACT'
